import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import {
  client,
  serverUrl,
  apiEndpoints,
  filesystem_root,
  subdomain,
} from "../../config";
import PostSingle from "../../partials/posts/postSingle";

export default function VideoSingle(props) {
  const [post, setPost] = useState(null);
  const params = useParams();

  const renderPostImage = () => {
    return <></>;
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.news}
      entityFavoritesContentType={"news"}
      preview={props.preview}
      previewReturnRoute={"/news-creator"}
      returnRoute={"/news"}
      backBtnText={"News Library"}
      screenClassName={"news"}
      v2Bundle={"news"}
      logCustomEventType={"News"}
      entityType={"news"}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      {post && renderPostImage(post)}
    </PostSingle>
  );
}
